<template>
  <div class="page-chooseUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_banner.jpg">
      <ul class="content">
        <li @click.stop="showChange('0')" :class="{'active':tab=='0'}">
          <div class="title">
            <p>核心优势</p>
          </div>
        </li>
        <li @click.stop="showChange('1')" :class="{'active':tab=='1'}">
          <div class="title">
            <p>专业课程</p>
          </div>
        </li>
        <li @click.stop="showChange('2')" :class="{'active':tab=='2'}">
          <div class="title">
            <p>QA体系</p>
          </div>
        </li>
        <li @click.stop="showChange('3')" :class="{'active':tab=='3'}">
          <div class="title">
            <p>透明管理</p>
          </div>
        </li>
        <li @click.stop="showChange('4')" :class="{'active':tab=='4'}">
          <div class="title">
            <p>食品健康</p>
          </div>
        </li>
        <li @click.stop="showChange('5')" :class="{'active':tab=='5'}">
          <div class="title">
            <p>家长说</p>
          </div>
        </li>
      </ul>
    </div>
    <!--核心优势-->
    <Advantage v-show="tab=='0'"></Advantage>
    <!--专业课程-->
    <Course v-show="tab=='1'"></Course>
    <!--QA体系-->
    <QA v-show="tab=='2'"></QA>
    <!--透明管理-->
    <Manage v-show="tab=='3'"></Manage>
    <!--食品健康-->
    <Foodhealth v-show="tab=='4'"></Foodhealth>
    <!-- 家长说 -->
    <Parents v-show="tab=='5'"></Parents>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>


<script>
import Header from "@/components/header/Header"; //悬浮头部
import Advantage from "@/pages/choose/advantage"; //核心优势
import Course from "@/pages/choose/course"; //专业课程
import QA from "@/pages/choose/qa"; //QA体系
import Manage from "@/pages/choose/manage"; //透明管理
import Foodhealth from "@/pages/choose/foodhealth"; //食品健康
import Parents from "@/pages/choose/parents"; //家长说
import Footer from "@/components/footer/footer"; //底部模块

export default {
  data() {
    return {
      //    tab: this.$route.query.id,
      tab: ""
    };
  },
  components: {
    Header,
    Advantage,
    Course,
    QA,
    Manage,
    Foodhealth,
    Parents,
    "v-footer": Footer
  },
  mounted() {
    //this.$nextTick(() => {
    this.getTab();
    //})
  },
  beforeRouteUpdate() {},
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/choose") > -1) {
        this.getTab();
      }
    }
  },
  methods: {
    getTab() {
      let route = this.$route.path;
      if (route.indexOf("/advantage") > -1) {
        this.tab = "0";
      } else if (route.indexOf("/course") > -1) {
        this.tab = "1";
      } else if (route.indexOf("/qa") > -1) {
        this.tab = "2";
      } else if (route.indexOf("/manage") > -1) {
        this.tab = "3";
      } else if (route.indexOf("/foodhealth") > -1) {
        this.tab = "4";
      } else if (route.indexOf("/parents") > -1) {
        this.tab = "5";
      }
    },
    showChange(val) {
      this.tab = val;
      switch (val) {
        case "0":
          this.$router.push({ name: "advantage" });
          break;
        case "1":
          this.$router.push({ name: "course" });
          break;
        case "2":
          this.$router.push({ name: "qa" });
          break;
        case "3":
          this.$router.push({ name: "manage" });
          break;
        case "4":
          this.$router.push({ name: "foodhealth" });
          break;
        case "5":
          this.$router.push({ name: "parents" });
          break;
        default:
          break;
      }
    }
  }
};
</script>


<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-chooseUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        width: auto;
        padding: 0px 50px;
        height: 68px;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: 100%;
            height: 68px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
}
@media (max-width: 767px) {
  .page-chooseUs {
    .banner {
      padding-top: 45px;
      .content {
        width: 100%;
        position: absolute;
        left: 0;
        margin-left: 0;
        bottom: 0;
        height: 35px;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          padding: 0;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px;
            }
            p {
              width: auto;
              padding: 0 24px;
              height: 35px;
              font-size: 14px;
              line-height: 35px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/choose/chooseUs.vue